// import { UseFormReturn } from "react-hook-form";
// import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material"
// import TabsHeader from "../../../../Components/Shared/TabsHeader";
// import { CompanyCharacteristicsFinepModel } from "../../../../Models/CompanyCharacteristicsFinepModel";
// import { SectoralAspectsFinepModel } from "../../../../Models/SectoralAspectsFinepModel";
// import { useContext, useEffect, useState } from "react";
// import { ICompanyActionForm } from "../../../../Interfaces/ICompanyActionFormProps";
// import useLoading from "../../../../Hooks/useLoading";
// import { IResponseProps } from "../../../../Interfaces/IResponseProps";
// import { toast } from "react-toastify";
// import { PostCompanyCharacteristicsFinepAPI, PostSectoralAspectsFinepAPI, PutCompanyCharacteristicsFinepAPI, PutSectoralAspectsFinepAPI } from "../../../../API/CompanyActionFinepAPI";
// import Loader from "../../../../Components/Shared/Loader";
// import { TechnologicalFeaturesFinepContext } from "../../../../Contexts/TechnologicalFeaturesFinepContext";

// interface ICompanyActionTabProps {
//     companyActionForm: UseFormReturn<ICompanyActionForm, any>,
//     calculatePercentage: (isValidated: boolean, tabName: string, qtdFilled: number) => void,
//     getFilledSecondTabCount: (dataComp?: CompanyCharacteristicsFinepModel, dataSec?: SectoralAspectsFinepModel) => number,
//     canValidateSecondTab: boolean,
//     setCanValidateSecondTab: React.Dispatch<React.SetStateAction<boolean>>
// }

// const CompanyActionTab = (props: ICompanyActionTabProps) => {
//     const { watch, register, setValue, getValues, formState } = props.companyActionForm;
//     const { isDirty } = formState;
//     const { loading, toggleLoading } = useLoading();
//     const [hasValidated, setHasValidated] = useState<boolean>(false);
//     const topCustomersFields = 4;
//     const mainCompaniesFields = 4;
//     const CompanyActionFields = 10;

//     const watchIsValid = watch("companyCharacteristics.isValid");
//     const { handleFillTab } = useContext(TechnologicalFeaturesFinepContext);

//     const PostCompanyCharacteristicsFinep = async (data: CompanyCharacteristicsFinepModel) => {
//         try {
//             toggleLoading(true);

//             if (data.mainDifference?.toString() == "") {
//                 data.mainDifference = undefined;
//             }

//             if (data.bestMarketing?.toString() == "") {
//                 data.bestMarketing = undefined;
//             }

//             if (!data.topCustomersFineps?.find(x => x.title != "") || data.topCustomersFineps == null) {
//                 data.topCustomersFineps = undefined;
//             }

//             await PostCompanyCharacteristicsFinepAPI(data).then((resp: IResponseProps) => {
//                 if (resp.statusCode == 200) {
//                     var dataResp = resp.data;
//                     setValue('companyCharacteristics.id', dataResp.id);
//                     handleFillTab(1)

//                 }
//             });
//         } catch (error: any) {
//             toast.error(error);
//         } finally {
//             toggleLoading(false);
//         }
//     }

//     const PostSectoralAspectsFinep = async (data: SectoralAspectsFinepModel) => {
//         try {
//             toggleLoading(true);

//             if (data.relevanceAvaliation?.toString() == "") {
//                 data.relevanceAvaliation = undefined;
//             }

//             if (!data.mainCompaniesFineps?.find(x => x.title != "") || data.mainCompaniesFineps == null) {
//                 data.mainCompaniesFineps = undefined;
//             }

//             await PostSectoralAspectsFinepAPI(data).then((resp: IResponseProps) => {
//                 if (resp.statusCode == 200) {
//                     var dataResp = resp.data;

//                     setValue('sectoralAspects.id', dataResp.id);
//                     handleFillTab(1)

//                 }
//             });
//         } catch (error: any) {
//             toast.error(error);
//         } finally {
//             toggleLoading(false);
//         }
//     }

//     const PutCompanyCharacteristicsFinep = async (data: CompanyCharacteristicsFinepModel) => {
//         try {
//             toggleLoading(true);

//             if (data.mainDifference?.toString() == "") {
//                 data.mainDifference = undefined;
//             }

//             if (data.bestMarketing?.toString() == "") {
//                 data.bestMarketing = undefined;
//             }

//             if (!data.topCustomersFineps?.find(x => x.title != "") || data.topCustomersFineps == null) {
//                 data.topCustomersFineps = undefined;
//             }

//             await PutCompanyCharacteristicsFinepAPI(data);
//             handleFillTab(1)

//         } catch (error: any) {
//             toast.error(error);
//         } finally {
//             toggleLoading(false);
//         }
//     }

//     const PutSectoralAspectsFinep = async (data: SectoralAspectsFinepModel) => {
//         try {
//             toggleLoading(true);

//             if (data.relevanceAvaliation?.toString() == "") {
//                 data.relevanceAvaliation = undefined;
//             }

//             if (!data.mainCompaniesFineps?.find(x => x.title != "") || data.mainCompaniesFineps == null) {
//                 data.mainCompaniesFineps = undefined;
//             }

//             await PutSectoralAspectsFinepAPI(data);
//             handleFillTab(1)

//         } catch (error: any) {
//             toast.error(error);
//         } finally {
//             toggleLoading(false);
//         }
//     }

//     const submitCompanyActionForm = (data: ICompanyActionForm, isCompany: boolean) => {
//         if (isCompany) {
//             if (isDirty || hasValidated != data.companyCharacteristics.isValid) {
//                 data.companyCharacteristics.isValid = hasValidated;
//                 setValue('companyCharacteristics.isValid', hasValidated);

//                 data.companyCharacteristics.topCustomersFineps = data.companyCharacteristics.topCustomersFineps?.filter(x => x.title != "");

//                 if (data.companyCharacteristics.id != "") {
//                     PutCompanyCharacteristicsFinep(data.companyCharacteristics);
//                 } else {
//                     PostCompanyCharacteristicsFinep(data.companyCharacteristics);
//                 }
//             }
//         } else {
//             if (isDirty || hasValidated != data.sectoralAspects.isValid) {
//                 data.sectoralAspects.isValid = hasValidated;
//                 setValue('sectoralAspects.isValid', hasValidated);

//                 data.sectoralAspects.mainCompaniesFineps = data.sectoralAspects.mainCompaniesFineps?.filter(x => x.title != "");

//                 if (data.sectoralAspects.id != "") {
//                     PutSectoralAspectsFinep(data.sectoralAspects);
//                 } else {
//                     PostSectoralAspectsFinep(data.sectoralAspects);
//                 }
//             }
//         }

//         var filled = props.getFilledSecondTabCount(data.companyCharacteristics, data.sectoralAspects);

//         if (filled == CompanyActionFields) {
//             props.setCanValidateSecondTab(true);
//         } else {
//             props.setCanValidateSecondTab(false);
//         }

//         props.calculatePercentage(data.companyCharacteristics.isValid && data.sectoralAspects.isValid, 'companyPerformance', filled);
//     };

//     const saveTopCustomer = (index: number, data: ICompanyActionForm) => {
//         var topCustomers = data.companyCharacteristics.topCustomersFineps;
//         if (topCustomers != undefined) {
//             var title = topCustomers[index].title;
//             var percent = topCustomers[index].percent;

//             if ((title && title != "") && (percent && percent > 0)) {
//                 submitCompanyActionForm(data, true);
//             }
//         }
//     }

//     const saveMainCompany = (index: number, data: ICompanyActionForm) => {
//         var mainCompanies = data.sectoralAspects.mainCompaniesFineps;

//         if (mainCompanies != undefined) {
//             var title = mainCompanies[index].title;
//             var percent = mainCompanies[index].percent;

//             if ((title && title != "") && (percent && percent > 0)) {
//                 submitCompanyActionForm(data, false);
//             }
//         }
//     }

//     const generateCompField = () => {
//         var newArray = [];

//         for (var i = 0; i < topCustomersFields; i++) {
//             let index = i;

//             newArray.push(
//                 <div key={i} className="mt-3 d-flex align-items-center">
//                     <TextField
//                         className="w-100 me-4"
//                         label="Digite o Nome da Empresa"
//                         type="text"
//                         disabled={hasValidated}
//                         {...register(`companyCharacteristics.topCustomersFineps.${i}.title`, { onBlur: () => saveTopCustomer(index, getValues()) })}
//                     />
//                     <TextField
//                         className=""
//                         label="% de Participação"
//                         type="number"
//                         disabled={hasValidated}
//                         {...register(`companyCharacteristics.topCustomersFineps.${i}.percent`, { onBlur: () => saveTopCustomer(index, getValues()) })}
//                     />
//                 </div>
//             )
//         }

//         return newArray;
//     }

//     const generateSectoralField = () => {
//         var newArray = [];

//         for (var i = 0; i < mainCompaniesFields; i++) {
//             let index = i;

//             newArray.push(
//                 <div key={i} className="mt-3 d-flex align-items-center">
//                     <TextField
//                         className="w-100 me-4"
//                         label="Digite o Nome da Empresa"
//                         type="text"
//                         disabled={hasValidated}
//                         {...register(`sectoralAspects.mainCompaniesFineps.${i}.title`, { onBlur: () => saveMainCompany(index, getValues()) })}
//                     />
//                     <TextField
//                         className=""
//                         label="% de Participação"
//                         type="number"
//                         disabled={hasValidated}
//                         {...register(`sectoralAspects.mainCompaniesFineps.${i}.percent`, { onBlur: () => saveMainCompany(index, getValues()) })}
//                     />
//                 </div>
//             )
//         }

//         return newArray;
//     }

//     const updateHasValidated = () => {
//         setHasValidated(props.canValidateSecondTab == true ? JSON.parse(getValues("companyCharacteristics.isValid").toString()) : false);
//     }

//     useEffect(() => {
//         if (hasValidated.toString() != getValues("companyCharacteristics.isValid").toString() && hasValidated.toString() != getValues("sectoralAspects.isValid").toString()) {
//             submitCompanyActionForm(getValues(), false);
//         }
//     }, [hasValidated]);

//     useEffect(() => {
//         updateHasValidated();
//     }, [watchIsValid, props.canValidateSecondTab]);

//     return (
//         <div>
//             {loading && <Loader />}
//             <div className="p-4">
//                 <TabsHeader
//                     canValidate={props.canValidateSecondTab}
//                     setValueSelected={setHasValidated}
//                     valueSelected={hasValidated}
//                     registerId={getValues("companyCharacteristics.registerId")}
//                     cardName=""
//                     tabName=""
//                 />

//                 <h4 className="mt-4">
//                     <strong className="color-blue">
//                         Características da Empresa
//                     </strong>
//                 </h4>
//                 <div className="d-flex align-items-center mt-4">
//                     <strong className="me-4">Qual o principal mercado de atuação da empresa, ou seja, aquele em que a empresa obteve o maior faturamento nos últimos três anos?</strong>
//                     <FormControl className="ms-2">
//                         <InputLabel id="label-select-market">Selecione</InputLabel>
//                         <Select
//                             placeholder="Selecione"
//                             labelId="label-select-market"
//                             label="Selecione"
//                             disabled={hasValidated}
//                             className="w-100"
//                             value={getValues('companyCharacteristics.bestMarketing')?.toString() ?? ""}
//                             {...register('companyCharacteristics.bestMarketing', { onChange: () => submitCompanyActionForm(getValues(), true) })}
//                         >
//                             <MenuItem value="0">Estadual</MenuItem>
//                             <MenuItem value="1">Regional</MenuItem>
//                             <MenuItem value="2">Nacional</MenuItem>
//                             <MenuItem value="3">Mercosul</MenuItem>
//                             <MenuItem value="4">Estados Unidos</MenuItem>
//                             <MenuItem value="5">Europa</MenuItem>
//                             <MenuItem value="6">Ásia</MenuItem>
//                             <MenuItem value="7">Outros Países</MenuItem>
//                         </Select>
//                     </FormControl>
//                 </div>
//                 <div className="mt-4">
//                     <TextField
//                         className="w-100"
//                         label="Descreva os principais produtos e mercados de exportação da Empresa"
//                         type="text"
//                         disabled={hasValidated}
//                         {...register('companyCharacteristics.mainMarketSegment', { onBlur: () => submitCompanyActionForm(getValues(), true) })}
//                     />
//                 </div>
//                 <strong className="d-block mt-4">Informe os principais clientes da empresa (até 4 clientes) Caso a empresa atue no ramo de varejo, preencha os campos com zero</strong>
//                 <p>(Ao menos uma empresa digitada)</p>

//                 {generateCompField()}

//                 <strong className="d-block mt-4">Quais são os principais diferenciais da empresa em relação aos concorrentes?</strong>
//                 <FormControl className="mt-2 w-75">
//                     <Select
//                         placeholder="Selecione"
//                         className="w-100"
//                         disabled={hasValidated}
//                         value={getValues('companyCharacteristics.mainDifference')?.toString() ?? ""}
//                         {...register('companyCharacteristics.mainDifference', { onBlur: () => submitCompanyActionForm(getValues(), true) })}
//                     >
//                         <MenuItem value="0">Custo</MenuItem>
//                         <MenuItem value="1">Qualidade</MenuItem>
//                         <MenuItem value="2">Tecnologia</MenuItem>
//                         <MenuItem value="3">Marketing</MenuItem>
//                         <MenuItem value="4">Fornecedores</MenuItem>
//                         <MenuItem value="5">Vantagens regulatórias</MenuItem>
//                         <MenuItem value="6">Nenhum</MenuItem>
//                         <MenuItem value="7">Outros especificar</MenuItem>
//                     </Select>
//                 </FormControl>

//                 {String(getValues('companyCharacteristics.mainDifference')) == "7" &&
//                     <TextField
//                         id="form-select"
//                         disabled={hasValidated}
//                         className="w-100 mt-4"
//                         label="Municípios onde há produção"
//                         {...register('companyCharacteristics.other', { onBlur: () => submitCompanyActionForm(getValues(), true) })}
//                     />
//                 }

//                 <h4 className="d-block mt-4">
//                     <strong className="color-blue">
//                         Aspectos Setoriais
//                     </strong>
//                 </h4>
//                 <strong className="d-block mt-3">Indique a participação de mercado da empresa no setor informado no cadastro da CNAE e sua posição relativa:</strong>
//                 <div className="d-flex mt-4">
//                     <div className="d-flex flex-column align-items-center me-4">
//                         <strong className="color-blue">Participação %</strong>
//                         <TextField
//                             className="w-100 mt-2"
//                             type="number"
//                             disabled={hasValidated}
//                             {...register('sectoralAspects.participation', { onBlur: () => submitCompanyActionForm(getValues(), false) })}
//                         />
//                     </div>
//                     <div className="d-flex flex-column align-items-center me-4">
//                         <strong className="color-blue">Posição Relativa</strong>
//                         <TextField
//                             className="w-100 mt-2"
//                             type="number"
//                             disabled={hasValidated}
//                             {...register('sectoralAspects.relativePosition', { onBlur: () => submitCompanyActionForm(getValues(), false) })}
//                         />
//                     </div>
//                 </div>
//                 <strong className="d-block mt-4">Indique as demais empresas com maior participação de mercado no setor (informe até 4 empresas)</strong>
//                 <p>(Ao Menos uma empresa)</p>

//                 {generateSectoralField()}

//                 <div className="w-75">
//                     <div className="d-flex align-items-center justify-content-between mt-4">
//                         <strong className="d-block me-4 w-100">Avalie a relevância das barreiras de entrada no setor de atuação da empresa</strong>
//                         <FormControl className="mt-2 w-75">
//                             <InputLabel id="label-sector">Selecione</InputLabel>
//                             <Select
//                                 placeholder="Selecione"
//                                 className="w-100"
//                                 disabled={hasValidated}
//                                 labelId="label-sector"
//                                 label="Selecione"
//                                 value={getValues('sectoralAspects.relevanceAvaliation')?.toString() ?? ""}
//                                 {...register('sectoralAspects.relevanceAvaliation', { onBlur: () => submitCompanyActionForm(getValues(), true) })}
//                             >
//                                 <MenuItem value="0">Alta</MenuItem>
//                                 <MenuItem value="1">Media</MenuItem>
//                                 <MenuItem value="2">Baixa</MenuItem>
//                                 <MenuItem value="3">Nenhuma</MenuItem>
//                             </Select>
//                         </FormControl>
//                     </div>
//                     <TextField
//                         className="w-100 mt-4"
//                         label="Novas tecnologias introduzidas nos últimos 3 anos afetaram o setor de atuação da empresa? Justifique:"
//                         type="text"
//                         disabled={hasValidated}
//                         {...register('sectoralAspects.technologiesIntroducedLast3YearsImpact', { onBlur: () => submitCompanyActionForm(getValues(), false) })}
//                     />
//                     <TextField
//                         className="w-100 mt-3"
//                         label="Novas tecnologias PODEM afetar o setor de atuação da empresa nos próximos 3 anos? Justifique:"
//                         type="text"
//                         disabled={hasValidated}
//                         {...register('sectoralAspects.futureTechnologiesNext3YearsImpact', { onBlur: () => submitCompanyActionForm(getValues(), false) })}
//                     />
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default CompanyActionTab;












import { UseFormReturn } from "react-hook-form";
import { Form, Input, InputNumber, Select, Typography } from "antd";
import TabsHeader from "../../../../Components/Shared/TabsHeader";
import { CompanyCharacteristicsFinepModel } from "../../../../Models/CompanyCharacteristicsFinepModel";
import { SectoralAspectsFinepModel } from "../../../../Models/SectoralAspectsFinepModel";
import { useContext, useEffect, useState } from "react";
import { ICompanyActionForm } from "../../../../Interfaces/ICompanyActionFormProps";
import useLoading from "../../../../Hooks/useLoading";
import { IResponseProps } from "../../../../Interfaces/IResponseProps";
import { toast } from "react-toastify";
import { PostCompanyCharacteristicsFinepAPI, PostSectoralAspectsFinepAPI, PutCompanyCharacteristicsFinepAPI, PutSectoralAspectsFinepAPI } from "../../../../API/CompanyActionFinepAPI";
import Loader from "../../../../Components/Shared/Loader";
import { TechnologicalFeaturesFinepContext } from "../../../../Contexts/TechnologicalFeaturesFinepContext";
interface ICompanyActionTabProps {
    companyActionForm: UseFormReturn<ICompanyActionForm, any>,
    calculatePercentage: (isValidated: boolean, tabName: string, qtdFilled: number) => void,
    getFilledSecondTabCount: (dataComp?: CompanyCharacteristicsFinepModel, dataSec?: SectoralAspectsFinepModel) => number,
    canValidateSecondTab: boolean,
    setCanValidateSecondTab: React.Dispatch<React.SetStateAction<boolean>>
}
const { Text, Title } = Typography;
const { Option } = Select;

const CompanyActionTab = (props: ICompanyActionTabProps) => {
    const { watch, register, setValue, getValues, formState } = props.companyActionForm;
    const { isDirty } = formState;
    const { loading, toggleLoading } = useLoading();
    const [hasValidated, setHasValidated] = useState<boolean>(false);
    const topCustomersFields = 4;
    const mainCompaniesFields = 4;
    const CompanyActionFields = 10;
    const watchIsValid = watch("companyCharacteristics.isValid");
    const { handleFillTab } = useContext(TechnologicalFeaturesFinepContext);
    const PostCompanyCharacteristicsFinep = async (data: CompanyCharacteristicsFinepModel) => {
        try {
            toggleLoading(true);
            if (data.mainDifference?.toString() == "") {
                data.mainDifference = undefined;
            }
            if (data.bestMarketing?.toString() == "") {
                data.bestMarketing = undefined;
            }
            if (!data.topCustomersFineps?.find(x => x.title != "") || data.topCustomersFineps == null) {
                data.topCustomersFineps = undefined;
            }
            await PostCompanyCharacteristicsFinepAPI(data).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    var dataResp = resp.data;
                    setValue('companyCharacteristics.id', dataResp.id);
                    handleFillTab(1)
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }
    const PostSectoralAspectsFinep = async (data: SectoralAspectsFinepModel) => {
        try {
            toggleLoading(true);
            if (data.relevanceAvaliation?.toString() == "") {
                data.relevanceAvaliation = undefined;
            }
            if (!data.mainCompaniesFineps?.find(x => x.title != "") || data.mainCompaniesFineps == null) {
                data.mainCompaniesFineps = undefined;
            }
            await PostSectoralAspectsFinepAPI(data).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    var dataResp = resp.data;
                    setValue('sectoralAspects.id', dataResp.id);
                    handleFillTab(1)
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }
    const PutCompanyCharacteristicsFinep = async (data: CompanyCharacteristicsFinepModel) => {
        try {
            toggleLoading(true);
            if (data.mainDifference?.toString() == "") {
                data.mainDifference = undefined;
            }
            if (data.bestMarketing?.toString() == "") {
                data.bestMarketing = undefined;
            }
            if (!data.topCustomersFineps?.find(x => x.title != "") || data.topCustomersFineps == null) {
                data.topCustomersFineps = undefined;
            }
            await PutCompanyCharacteristicsFinepAPI(data);
            handleFillTab(1)
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }
    const PutSectoralAspectsFinep = async (data: SectoralAspectsFinepModel) => {
        try {
            toggleLoading(true);
            if (data.relevanceAvaliation?.toString() == "") {
                data.relevanceAvaliation = undefined;
            }
            if (!data.mainCompaniesFineps?.find(x => x.title != "") || data.mainCompaniesFineps == null) {
                data.mainCompaniesFineps = undefined;
            }
            await PutSectoralAspectsFinepAPI(data);
            handleFillTab(1)
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }
    const submitCompanyActionForm = (data: ICompanyActionForm, isCompany: boolean) => {
        if (isCompany) {
            if (isDirty || hasValidated != data.companyCharacteristics.isValid) {
                data.companyCharacteristics.isValid = hasValidated;
                setValue('companyCharacteristics.isValid', hasValidated);
                data.companyCharacteristics.topCustomersFineps = data.companyCharacteristics.topCustomersFineps?.filter(x => x.title != "");
                if (data.companyCharacteristics.id != "") {
                    PutCompanyCharacteristicsFinep(data.companyCharacteristics);
                } else {
                    PostCompanyCharacteristicsFinep(data.companyCharacteristics);
                }
            }
        } else {
            if (isDirty || hasValidated != data.sectoralAspects.isValid) {
                data.sectoralAspects.isValid = hasValidated;
                setValue('sectoralAspects.isValid', hasValidated);
                data.sectoralAspects.mainCompaniesFineps = data.sectoralAspects.mainCompaniesFineps?.filter(x => x.title != "");
                if (data.sectoralAspects.id != "") {
                    PutSectoralAspectsFinep(data.sectoralAspects);
                } else {
                    PostSectoralAspectsFinep(data.sectoralAspects);
                }
            }
        }
        var filled = props.getFilledSecondTabCount(data.companyCharacteristics, data.sectoralAspects);
        if (filled == CompanyActionFields) {
            props.setCanValidateSecondTab(true);
        } else {
            props.setCanValidateSecondTab(false);
        }
        props.calculatePercentage(data.companyCharacteristics.isValid && data.sectoralAspects.isValid, 'companyPerformance', filled);
    };
    const saveTopCustomer = (index: number, data: ICompanyActionForm) => {
        var topCustomers = data.companyCharacteristics.topCustomersFineps;
        if (topCustomers != undefined) {
            var title = topCustomers[index].title;
            var percent = topCustomers[index].percent;
            if ((title && title != "") && (percent && percent > 0)) {
                submitCompanyActionForm(data, true);
            }
        }
    }
    const saveMainCompany = (index: number, data: ICompanyActionForm) => {
        var mainCompanies = data.sectoralAspects.mainCompaniesFineps;
        if (mainCompanies != undefined) {
            var title = mainCompanies[index].title;
            var percent = mainCompanies[index].percent;
            if ((title && title != "") && (percent && percent > 0)) {
                submitCompanyActionForm(data, false);
            }
        }
    }
    const generateCompField = () => {
        var newArray = [];
        for (var i = 0; i < topCustomersFields; i++) {
            let index = i;
            newArray.push(
                <div key={i} className="mt-3 d-flex align-items-center">
                    <Input
                        className="w-100 me-4"
                        placeholder="Digite o Nome da Empresa"
                        disabled={hasValidated}
                        defaultValue={getValues(`companyCharacteristics.topCustomersFineps.${i}.title`)}
                        onChange={(e) => setValue(`companyCharacteristics.topCustomersFineps.${i}.title`, e.target.value)}
                        onBlur={() => saveTopCustomer(index, getValues())}
                    />
                    <InputNumber
                        className="w-100"
                        placeholder="% de Participação"
                        disabled={hasValidated}
                        defaultValue={getValues(`companyCharacteristics.topCustomersFineps.${i}.percent`)}
                        onChange={(value) => setValue(`companyCharacteristics.topCustomersFineps.${i}.percent`, value as number)}
                        onBlur={() => saveTopCustomer(index, getValues())}
                    />
                </div>
            )
        }
        return newArray;
    }
    const generateSectoralField = () => {
        var newArray = [];
        for (var i = 0; i < mainCompaniesFields; i++) {
            let index = i;
            newArray.push(
                <div key={i} className="mt-3 d-flex align-items-center">
                    <Input
                        className="w-100 me-4"
                        placeholder="Digite o Nome da Empresa"
                        disabled={hasValidated}
                        defaultValue={getValues(`sectoralAspects.mainCompaniesFineps.${i}.title`)}
                        onChange={(e) => setValue(`sectoralAspects.mainCompaniesFineps.${i}.title`, e.target.value)}
                        onBlur={() => saveMainCompany(index, getValues())}
                    />
                    <InputNumber
                        className="w-100"
                        placeholder="% de Participação"
                        disabled={hasValidated}
                        defaultValue={getValues(`sectoralAspects.mainCompaniesFineps.${i}.percent`)}
                        onChange={(value) => setValue(`sectoralAspects.mainCompaniesFineps.${i}.percent`, value as number)}
                        onBlur={() => saveMainCompany(index, getValues())}
                    />
                </div>
            )
        }
        return newArray;
    }
    const updateHasValidated = () => {
        setHasValidated(props.canValidateSecondTab == true ? JSON.parse(getValues("companyCharacteristics.isValid").toString()) : false);
    }
    useEffect(() => {
        if (hasValidated.toString() != getValues("companyCharacteristics.isValid").toString() && hasValidated.toString() != getValues("sectoralAspects.isValid").toString()) {
            submitCompanyActionForm(getValues(), false);
        }
    }, [hasValidated]);
    useEffect(() => {
        updateHasValidated();
    }, [watchIsValid, props.canValidateSecondTab]);
    return (
        <div>
            {loading && <Loader />}
            <div className="p-4">
                <TabsHeader
                    canValidate={props.canValidateSecondTab}
                    setValueSelected={setHasValidated}
                    valueSelected={hasValidated}
                    registerId={getValues("companyCharacteristics.registerId")}
                    cardName=""
                    tabName=""
                />
                <Title level={4} style={{ color: '#000085', fontSize: '22px', fontWeight: 'normal' }}>Características da Empresa</Title>
                <div className="d-flex align-items-center mt-4">
                    <Form.Item 
                        label="Qual o principal mercado de atuação da empresa, ou seja, aquele em que a empresa obteve o maior faturamento nos últimos três anos?"
                        labelCol={{ span: 24 }}
                        className="w-100"
                    >
                        <Select
                            placeholder="Selecione"
                            disabled={hasValidated}
                            className="w-100"
                            value={getValues('companyCharacteristics.bestMarketing')?.toString() ?? ""}
                            onChange={(value: string) => {
                                setValue('companyCharacteristics.bestMarketing', parseInt(value));
                                submitCompanyActionForm(getValues(), true);
                            }}
                        >
                            <Option value="0">Estadual</Option>
                            <Option value="1">Regional</Option>
                            <Option value="2">Nacional</Option>
                            <Option value="3">Mercosul</Option>
                            <Option value="4">Estados Unidos</Option>
                            <Option value="5">Europa</Option>
                            <Option value="6">Ásia</Option>
                            <Option value="7">Outros Países</Option>
                        </Select>
                    </Form.Item>
                </div>
                <div className="mt-4">
                    <Text className="me-2 text-nowrap">Descreva os principais produtos e mercados de exportação da Empresa:</Text>
                    <Input
                        className="w-100"
                        placeholder="Descreva aqui..."
                        disabled={hasValidated}
                        defaultValue={getValues('companyCharacteristics.mainMarketSegment')}
                        onChange={(e) => setValue('companyCharacteristics.mainMarketSegment', e.target.value)}
                        onBlur={() => submitCompanyActionForm(getValues(), true)}
                    />
                </div>
                <Text className="d-block mt-4">Informe os principais clientes da empresa (até 4 clientes) Caso a empresa atue no ramo de varejo, preencha os campos com zero</Text>
                <p>(Ao menos uma empresa digitada)</p>
                {generateCompField()}
                <Text className="d-block mt-4">Quais são os principais diferenciais da empresa em relação aos concorrentes?</Text>
                <Form.Item className="mt-2 w-75">
                    <Select
                        placeholder="Selecione"
                        className="w-100"
                        disabled={hasValidated}
                        value={getValues('companyCharacteristics.mainDifference')?.toString() ?? ""}
                        onChange={(value: string) => {
                            setValue('companyCharacteristics.mainDifference', parseInt(value));
                            submitCompanyActionForm(getValues(), true);
                        }}
                    >
                        <Option value="0">Custo</Option>
                        <Option value="1">Qualidade</Option>
                        <Option value="2">Tecnologia</Option>
                        <Option value="3">Marketing</Option>
                        <Option value="4">Fornecedores</Option>
                        <Option value="5">Vantagens regulatórias</Option>
                        <Option value="6">Nenhum</Option>
                        <Option value="7">Outros especificar</Option>
                    </Select>
                </Form.Item>
                {String(getValues('companyCharacteristics.mainDifference')) == "7" &&
                    <Input
                        disabled={hasValidated}
                        className="w-100 mt-4"
                        placeholder="Municípios onde há produção"
                        defaultValue={getValues('companyCharacteristics.other')}
                        onChange={(e) => setValue('companyCharacteristics.other', e.target.value)}
                        onBlur={() => submitCompanyActionForm(getValues(), true)}
                    />
                }
                <h4 className="d-block mt-4">
                    <strong className="color-blue">
                        Aspectos Setoriais
                    </strong>
                </h4>
                <Text className="d-block mt-3">Indique a participação de mercado da empresa no setor informado no cadastro da CNAE e sua posição relativa:</Text>
                <div className="d-flex mt-4">
                    <div className="d-flex flex-column align-items-center me-4">
                        <Text className="color-blue">Participação %</Text>
                        <InputNumber
                            className="w-100 mt-2"
                            disabled={hasValidated}
                            defaultValue={getValues('sectoralAspects.participation')}
                            onChange={(value) => setValue('sectoralAspects.participation', value as number)}
                            onBlur={() => submitCompanyActionForm(getValues(), false)}
                        />
                    </div>
                    <div className="d-flex flex-column align-items-center me-4">
                        <Text className="color-blue">Posição Relativa</Text>
                        <InputNumber
                            className="w-100 mt-2"
                            disabled={hasValidated}
                            defaultValue={getValues('sectoralAspects.relativePosition')}
                            onChange={(value) => setValue('sectoralAspects.relativePosition', value as number)}
                            onBlur={() => submitCompanyActionForm(getValues(), false)}
                        />
                    </div>
                </div>
                <Text className="d-block mt-4">Indique as demais empresas com maior participação de mercado no setor (informe até 4 empresas)</Text>
                <p>(Ao Menos uma empresa)</p>
                {generateSectoralField()}
                <div className="w-75">
                    <div className="d-flex align-items-center justify-content-between mt-4">
                        <Text className="d-block me-4 w-100">Avalie a relevância das barreiras de entrada no setor de atuação da empresa</Text>
                        <Form.Item className="mt-2 w-75">
                            <Select
                                placeholder="Selecione"
                                className="w-100"
                                disabled={hasValidated}
                                value={getValues('sectoralAspects.relevanceAvaliation')?.toString() ?? ""}
                                onChange={(value: string) => {
                                    setValue('sectoralAspects.relevanceAvaliation', parseInt(value));
                                    submitCompanyActionForm(getValues(), true);
                                }}
                            >
                                <Option value="0">Alta</Option>
                                <Option value="1">Media</Option>
                                <Option value="2">Baixa</Option>
                                <Option value="3">Nenhuma</Option>
                            </Select>
                        </Form.Item>
                    </div>
                    <Input
                        className="w-100 mt-4"
                        placeholder="Novas tecnologias introduzidas nos últimos 3 anos afetaram o setor de atuação da empresa? Justifique:"
                        disabled={hasValidated}
                        defaultValue={getValues('sectoralAspects.technologiesIntroducedLast3YearsImpact')}
                        onChange={(e) => setValue('sectoralAspects.technologiesIntroducedLast3YearsImpact', e.target.value)}
                        onBlur={() => submitCompanyActionForm(getValues(), false)}
                    />
                    <Input
                        className="w-100 mt-3"
                        placeholder="Novas tecnologias PODEM afetar o setor de atuação da empresa nos próximos 3 anos? Justifique:"
                        disabled={hasValidated}
                        defaultValue={getValues('sectoralAspects.futureTechnologiesNext3YearsImpact')}
                        onChange={(e) => setValue('sectoralAspects.futureTechnologiesNext3YearsImpact', e.target.value)}
                        onBlur={() => submitCompanyActionForm(getValues(), false)}
                    />
                </div>
            </div>
        </div>
    )
}
export default CompanyActionTab;